module.exports = __webpack_public_path__ + "img/1+1-Tafel_Zerlegung 10.9d689cc6.png";